module.exports = __webpack_public_path__ + "static/media/about-hero-desktop-1440x300.7e7b7918.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/aboutUs/assets/about-hero-desktop-1440x300.jpg
// module id = 1303
// module chunks = 1